import { memo } from "react";

import { IconCreator } from "./_utils/icon-creator";
import Warning from "../../../../public/assets/icon/system/warning.svg?react";

import type { SVGIconProps } from "./_utils/icon-creator";

const WarningIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: Warning });
	return <Icon />;
};

export default memo(WarningIcon);
